export const documentMap = [
  {
    document_name: "Pre-Auth",
    applicability: "Mandatory",
    "type": "Doc",
    admission_type: "All",
    case_type: "All",
    "file_source": "Pre-Auth",
    "hint": "Identify a pre-authorization request/form submitted by the hospital for cashless treatment approval. Look for patient details, hospital name, diagnosis, proposed treatment, estimated expenses, and authorization request."
  },
  {
    document_name: "KYC Doc (Aadhaar) Employee",
    applicability: "Mandatory",
    "type": "Doc",
    admission_type: "All",
    case_type: "All",
    "file_source": "Aadhaar Card",
    "hint": "Identify an Aadhaar identity document belonging to the employee/policyholder. Verify the document owner's name and Aadhaar identifier, which may be masked."
  },
  {
    document_name: "KYC Doc (Aadhaar) Member",
    applicability: "Mandatory",
    "type": "Doc",
    admission_type: "All",
    case_type: "All",
    "file_source": "Aadhaar Card",
    "hint": "Identify an Aadhaar identity document belonging to the patient/member. Check the name and identity details against the patient/member information."
  },
  {
    document_name: "KYC Doc (PAN) Employee",
    applicability: "Mandatory",
    "type": "Doc",
    admission_type: "All",
    case_type: "All",
    "file_source": "PAN Card",
    "hint": "Identify a PAN card belonging to the employee/policyholder. Look for the person's name and PAN identifier."
  },
  {
    document_name: "KYC Doc (PAN) Member",
    applicability: "Mandatory",
    "type": "Doc",
    admission_type: "All",
    case_type: "All",
    "file_source": "PAN Card",
    "hint": "Identify a PAN card belonging to the patient/member. Verify the document owner's name and PAN identifier against member details."
  },
  {
    document_name: "DOA",
    applicability: "Mandatory",
    "type": "Information",
    admission_type: "All",
    case_type: "Pre-Auth",
    "file_source": "Hospital Records / Pre-Auth",
    "hint": "Extract the Date of Admission (DOA), meaning the date the patient was admitted to the hospital. Look for admission date fields in the pre-authorization form, admission notes, hospital records, or other supporting documents. Return the date in a normalized format. Do not confuse it with the consultation date or procedure date."
  },
  {
    document_name: "DOD",
    applicability: "Mandatory",
    "type": "Information",
    admission_type: "All",
    case_type: "Pre-Auth",
    "file_source": "Hospital Records / Discharge Summary",
    "hint": "Extract the Date of Discharge (DOD), meaning the date the patient was discharged from the hospital. Look for discharge date fields in the discharge summary or hospital records. If the patient is still admitted or the date is not available, return Not Available rather than assuming a date."
  },
  // {
  //   document_name: "Employee ID Card",
  //   applicability: "Optional",
  //   "type": "Doc",
  //   admission_type: "All",
  //   case_type: "All",
  //   "file_source": "Employee ID Card",
  //   "hint": "Identify an employer-issued employee ID card. Look for employee name, employee number, employer name, and photograph where available. Distinguish it from a hospital ID or insurance card."
  // },
  {
    document_name: "Consultation Letter",
    applicability: "Mandatory",
    "type": "Doc",
    admission_type: "Planned",
    case_type: "All",
    "file_source": "Consultation Letter",
    "hint": "Identify a doctor's consultation letter, specialist referral, or medical advice related to the proposed hospitalization. Look for patient details, consultation date, diagnosis, doctor's details, and recommended treatment or admission."
  },
  {
    document_name: "Consultation Letter",
    applicability: "Optional",
    "type": "Doc",
    admission_type: "Emergency",
    case_type: "All",
    "file_source": "Consultation Letter",
    "hint": "Identify a doctor's consultation note, emergency assessment, referral, or medical advice related to an emergency admission. Look for presenting complaints, clinical findings, diagnosis, and admission recommendation."
  },
  {
    document_name: "Investigation Report",
    applicability: "Mandatory",
    "type": "Doc",
    admission_type: "Planned",
    case_type: "All",
    "file_source": "Investigation Report",
    "hint": "Identify diagnostic investigation reports relevant to the proposed hospitalization, including laboratory tests, X-rays, ultrasound, CT, MRI, ECG, or other diagnostic reports. Look for patient details, test date, investigation name, findings, and results."
  },
  {
    document_name: "Investigation Report",
    applicability: "Optional",
    "type": "Doc",
    admission_type: "Emergency",
    case_type: "All",
    "file_source": "Investigation Report",
    "hint": "Identify diagnostic reports generated during emergency evaluation or treatment. Look for patient details, test date, investigation name, findings, and results. Accept relevant preliminary reports where applicable."
  },
  {
    document_name: "Initial Assessment Sheet / Admission History Sheet",
    applicability: "Mandatory",
    "type": "Doc",
    admission_type: "Emergency",
    case_type: "All",
    "file_source": "Initial Assessment Sheet / Admission History Sheet",
    "hint": "Identify the initial hospital assessment, emergency assessment sheet, casualty record, or admission history. Look for presenting complaints, medical history, clinical findings, provisional diagnosis, admission date/time, and initial treatment."
  },
  {
    document_name: "Treatment Plan",
    applicability: "Mandatory",
    "type": "Doc",
    admission_type: "All",
    case_type: "All",
    "file_source": "Treatment Plan",
    "hint": "Identify the doctor's proposed treatment or management plan. Look for diagnosis, proposed procedure or surgery, medications, investigations, and treatment recommendations. Accept equivalent treatment or surgical plans."
  },
  {
    document_name: "Vital Chart",
    applicability: "Mandatory",
    "type": "Doc",
    admission_type: "Emergency",
    case_type: "All",
    "file_source": "Vital Chart",
    "hint": "Identify a hospital vital-sign monitoring chart or nursing observation sheet. Look for blood pressure, pulse, temperature, respiratory rate, oxygen saturation, and measurement dates/times."
  },
  {
    document_name: "Alcohol History at Incident",
    applicability: "Mandatory",
    "type": "Information",
    admission_type: "Emergency",
    case_type: "Accidental Case",
    "file_source": "Doctor Notes",
    "hint": "Extract documented alcohol-related history associated with the accident. Identify whether alcohol consumption was reported, denied, suspected, confirmed, or not mentioned. Do not infer consumption or treat missing information as a negative finding."
  },
  {
    document_name: "MLC/FIR Copy",
    applicability: "Mandatory",
    "type": "Docs",
    admission_type: "Emergency",
    case_type: "Accidental Case",
    "file_source": "MLC Copy",
    "hint": "Identify a Medico-Legal Case (MLC) report or First Information Report (FIR) related to the accident. Look for patient details, incident date, MLC/FIR number, accident circumstances, police station, and reporting authority."
  }
]